import React,{useState} from "react";
import styles from "./QuestionAnswers.scss";
import { RedButton } from "../Buttons/Buttons";
import { set } from "react-ga";
const Validation = (props) => {
  const {validationMsg,isCorrect,display} = props;
  
  
  return (
    <React.Fragment>
        
    <div style={{display:display,alignItems:"center",marginTop:"15px"}}>
        <div>
            {
                isCorrect ? <div style={{display:display,alignItems:"center"}}><img style={{width:"20px",height:"20px"}} alt="correct answer" src={`/preseedherbicide/images/checked.png`}/>&nbsp;<span>Correct Answer</span></div>:<div style={{display:display,alignItems:"center"}}><img alt="incorrect answer" style={{width:"20px",height:"20px"}} src={`/preseedherbicide/images/cancel.png`}/>&nbsp; <span>Incorrect Answer</span></div>
            }
         
        </div>
        <br/>
        <div>
          {validationMsg}
        </div>
   </div>

    </React.Fragment>
   
  );
};

export default Validation;